import type { AmbleContent } from "../..";
import { getAffordableQuotesGenericAgent } from "../../shared/get-affordable-quotes";
import { agentWithFormPromptTermsOfPolicy } from "../../shared/terms-of-policy";
import { wholesalerContactInfoAgentEmailCopy } from "../../shared/wholesaler-contact-info";

export const ambles: Record<string, AmbleContent> = {
  usa_business_get_affordable_quotes: getAffordableQuotesGenericAgent,
  usa_wholesaler_contact_information: wholesalerContactInfoAgentEmailCopy,
  terms_of_policy: agentWithFormPromptTermsOfPolicy,
};
